import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Fonts, Metrics } from '../../Themes'

const propTypes = {
  elements: PropTypes.array,
  children: PropTypes.node
}

const ListContainer = styled.div`
  margin-top: ${Metrics.margins.small};
  max-height: ${Metrics.components.listSize};
  overflow-y: scroll;
  display: ${props => (props.hide ? 'none' : 'block')};
  text-align: left;
  ${Fonts.style.Text};
`

const List = props => {
  const { children } = props
  return <ListContainer {...props}>{children}</ListContainer>
}

List.propTypes = propTypes

export default List



// WEBPACK FOOTER //
// ./src/components/List/index.js